import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../../shared/components/DashboardHeader';
import SideMenu from '../../shared/components/SideMenu';
import Footer from '../../shared/components/Footer';
import HttpCall from '../../api/Http';
import SerializeClass from '../../shared/Utils/serialized';
import User from '../../shared/Utils/User';
import axios from 'axios';
import Alert from '../../shared/Utils/AlertBox';
import Loader from '../../shared/components/Loader';
import Moment from 'react-moment';
import File from '../../shared/Utils/Filename';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from 'draft-js';
import { Link } from 'react-router-dom';

export default function Sequence() {

  const [sequenceID, setSequenceID] = useState(0);
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState({ name: "", template: "", searchText: "" });
  const [file, setFile] = useState(null)
  const [sequenceList, setSequenceList] = useState([])
  const [fileList, setFileList] = useState([])
  const [showPopup, setPopup] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());


  const { name, template, searchText } = inputValue;
  const user = User.getUser()

  useEffect(() => {
    getSequenceList();
  

  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  function onFileChange(event) {
    setFile(event.target.files);
  };

  const getSequenceList = (type) => {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    if (type == 0)
      arr.push({ P_Search_Text: searchText });

      let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getUserSequence?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setSequenceList(response.data.data);
      } else {
        alert(response.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function addSequence(e) {

    e.preventDefault();

    if (name.length < 2) {
      return Alert.show("Error!", 'Please enter the sequence name', "error");
    }
    if (!file && !template) {
      return Alert.show("Error!", 'Please enter the sequence Template or upload the file', "error");
    }
    let requestData = new FormData();
    let arr = [];
    if (sequenceID > 0) {
      arr.push({ P_id: sequenceID });
      arr.push({ P_updated_by: user[0].Id });
      requestData.append('sequence_id', sequenceID);
    } else {
      arr.push({ P_user_id: user[0].Id });
      arr.push({ P_created_by: user[0].Id });
    }
    //File.path(file ? file.name : null)
    arr.push({ P_file_path: '' });
    arr.push({ P_file_name: file ? '' : '' });
    arr.push({ P_sequence_name: name });
    arr.push({ P_sequence_template: template });

    if (file != null) {
      for (let i = 0; i < file.length; i++) {
        requestData.append('files', file[i]);
      }
    }
    requestData.append('user_id', user[0].Id);
    let p = SerializeClass.getSerializedData(arr);
    requestData.append('Params', p);


    let url = sequenceID ? '/api/user/updateSequence' : '/api/user/addSequence';
    setLoader(true)
    HttpCall.postRequest2(url, requestData).then(response => {
      setLoader(false)
      if (response.data.code == 200) {
        Alert.show("Success!", sequenceID ? "Sequence Updated Successfully." : "Sequence Added Successfully.", "success");
        getSequenceList(0);
        setInputValue(() => ({ name: '', template: '' }))
        setFile(null);
        window.location.reload(false);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
      setLoader(false)
    })
  }

  function editSequence(row) {
    setSequenceID(row.id);
    setInputValue(() => ({ name: row.sequence_name, template: row.sequence_template }))
  }


  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);

  }

  function showPopupData(row) {
    setPopup(true);
    let arr = [];
    arr.push({ 'P_sequence_id': row.id });
    let p = SerializeClass.getSerializedData(arr);
    let url = `https://api.getbound.ai/api/user/getSequenceFiles?Params=${p}`;
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {

        setFileList(response.data.data);

      } else {
        alert(response.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function onClosePopup() {
    setPopup(false);
  }

  function searchRecord(e) {
    e.preventDefault();
    getSequenceList(0);
  }

  function clearSearch(e) {
    e.preventDefault();
    setInputValue(() => ({ name: '', template: '', searchText: '' }))
    getSequenceList(1);
  }

  return (
    <>
      <DashboardHeader />
      {loader && <Loader />}
      <div className="container-fluid page-body-wrapper">

        <SideMenu />
        {showPopup && <div id="VerificationCode" class="modal" style={{ display: 'block', margin: '0 auto', paddingTop: 100 }}>

          <div className="col-lg-6 grid-margin stretch-card">
            <span class="close3 closebtn">&times;</span>
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Sequence Files</h4>
                <div className="table-responsive">
                  <table id="example" className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>File Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fileList.length > 0 && fileList.map((data, index) => (<tr key={index}>
                        <td>{index + 1}</td>
                        <td>{data._file_name}</td>
                        <td>
                          <a href={'https://content.getbound.ai/sequence_template/' + data.file_path} class="filename" id="filename" download>Download</a>
                        </td>
                      </tr>))}
                    </tbody>
                  </table>
                </div>

                <a class="filename customcrossbtn" id="filename" onClick={onClosePopup}>X</a>
              </div>
            </div>
          </div>
        </div>}

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">

              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Sequence > New Sequence</h4>
                    <p className="card-description">
                      Note: Provide the brief description of the sequence in the template section (including details of scheduling, messages/ contents, etc) or upload pdf, doc or CSV file
                    </p>

                    <form className="forms-sample">

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Sequence Name</label>
                        <input type="name" className="form-control form-control-lg"
                          value={name} name="name"
                          onChange={handleChange}
                          placeholder="Enter Sequence Name" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Sequence Template</label>
                        <textarea className="form-control form-control-lg customtextarea"
                          value={template} name="template" onChange={handleChange}
                          placeholder="Enter Description of the Sequence" rows="20"></textarea>
                      </div>
                      {/* <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Sequence Template</label>
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      onEditorStateChange={onEditorStateChange}
                    />
                    </div> */}


                      <div className="form-group">
                        <label>Browse File (IMAGE/CSV/PDF/DOC)</label>

                        <div className="input-group col-xs-12">
                          <input type="file" multiple onChange={onFileChange} accept="image/*, .doc,.docx,.csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.pdf" className="form-control file-upload-info form-control-lg marginsmall customchoosefile" placeholder="Upload File (IMAGE/CSV/PDF/DOC)" />

                        </div>
                      </div>
                      <div className="form-group">
                        <a href='https://content.getbound.ai/template_files/Outbound Sequence Template.pdf' target='_blank' download>Sequence Template</a>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={addSequence}>Save</button>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-light me-2 savebtn">Cancel</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Sequence </h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input type="text" className="form-control form-control-lg"
                            onChange={handleChange} value={searchText} name="searchText" placeholder='Search ' />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={searchRecord}>
                            Search
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={clearSearch}>
                            Clear Search
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Sequence Name</th>
                            <th>File Name</th>
                            <th>Created</th>
                            {/* <th>Status</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sequenceList.length > 0 && sequenceList.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.sequence_name}</td>
                            <td>
                              <span class="filenamebreak"><a style={{cursor: 'pointer', color: 'blue'}} onClick={() => showPopupData(data)}>View Files</a></span>
                            </td>
                            {/* <td>{format(new Date(data.created_on), 'dd-mm-yyy')}</td> */}
                            <td><Moment format="DD-MM-YYYY">{data.created_on}</Moment></td>
                            {/* <td><label className="badge badge-danger">{data.status_id}</label></td> */}
                            <td>
                              <button type="submit" className="btn btn-primary btn-sm savebtn" onClick={() => editSequence(data)}>Edit</button>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}